<mat-card>
  <mat-card-content class="flex flex-col gap-[20px]">
    <div>
      {{
        '+INSTALLATIONS.INSTALLATION.MISSED_HEATING_CIRCUIT_ASSIGNMENT_MODAL.MESSAGE' | translate
      }}
    </div>
  </mat-card-content>
  <mat-card-actions class="flex flex-row gap-[8px] justify-end items-center">
    <button
      id="close-btn"
      data-at-close-btn
      mat-button
      color="primary"
      gtm="onClose"
      gtmCategory="missedHcAssignementModal"
      (click)="onClose()"
    >
      {{ 'GENERAL.BUTTON.CLOSE' | translate }}
    </button>
    <button
      id="confirm-btn"
      data-at-go-to-settings-btn
      mat-raised-button
      color="primary"
      gtm="onConfirm"
      gtmCategory="missedHcAssignementModal"
      (click)="onConfirm()"
    >
      {{
        '+INSTALLATIONS.INSTALLATION.MISSED_HEATING_CIRCUIT_ASSIGNMENT_MODAL.GO_TO_SETTINGS_BUTTON'
          | translate
      }}
    </button>
  </mat-card-actions>
</mat-card>
